<div class="bb-identity-journey__container">
  <div class="bb-identity-journey__background-container">
    <div class="bb-identity-journey__background" aria-hidden="true"></div>
  </div>
  <div class="bb-identity-journey__body-container" data-role="identity-journey-wrapper-body">
    <div class="container container--fixed-width-small bb-identity-journey__body">
      <router-outlet></router-outlet>
    </div>
  </div>
</div>
